import type { Country, CountryCode, CountryDetails } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

const SERVICE_PATH = 'rest/resource/countries';

export function getBankCountries(): Promise<Country[]> {
    return get<Country[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function getReceiverResidenceCountries(): Promise<Country[]> {
    return get<Country[]>(`${CONTEXT_PATH}/${SERVICE_PATH}/receiver`);
}

export function getCountryDetails(countryCode: CountryCode): Promise<CountryDetails> {
    return get<CountryDetails>(`${CONTEXT_PATH}/${SERVICE_PATH}/${countryCode.value}`);
}
